import { z } from "zod";

const translationPath = "page.4uMarCom.automationRules.marcom_timerule.errors.";

const typeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "type" }
);

const timeClassificationSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "time_classification" }
);

export const timeRuleSchema = z.object({
  id: z.string().optional(),
  value: z.string().min(1, translationPath + "value"),
  type: typeSchema.nullable().refine((val) => val, {
    message: translationPath + "type",
  }),
  timeClassification: timeClassificationSchema.nullable().refine((val) => val, {
    message: translationPath + "time_classification",
  }),
});

export type TTimeRuleForm = z.infer<typeof timeRuleSchema>;
